<!-- 根据类型进行渲染 -->
<ng-container [ngSwitch]="component.widget">
  <!-- <ng-container *ngSwitchCase="'layout-form'">
    <ng-container *ngTemplateOutlet="formRender; context: { $implicit: component, parentComponent: parentComponent }"> </ng-container>
  </ng-container> -->
  <ng-container *ngSwitchCase="'group'">
    <ng-container *ngTemplateOutlet="groupRender; context: { $implicit: component, parentComponent: parentComponent }"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'title'">
    <ng-container *ngTemplateOutlet="titleRender; context: { $implicit: component, parentComponent: parentComponent }"></ng-container>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="defaultRender; context: { $implicit: component, parentComponent: parentComponent }"></ng-container>
  </ng-container>
</ng-container>

<!-- 表单 -->
<!-- <ng-template #formRender let-subComponent let-parentComponent="parentComponent">
  <form #widgetFormRef="ngForm" nz-row nz-form style="height: 100%" [ngClass]="{ formBordered: parentComponent.bordered }">
    <div class="widget-form-list" style="width: 100%; text-align: left">
      <ng-container *ngFor="let component of parentComponent.children; let i = index">
        <div
          nz-col
          [nzMd]="component.span || 12"
          [nzXs]="24"
          [nzOffset]="component.offset || 0"
          class="widget-form-list-item"
          [attr.data-id]="component.id"
          [attr.id]="'widget-' + component.id"
          style="display: inline-block; width: 100%; float: left"
        >
          <div>
            <div r-widget-form-render [parentComponent]="parentComponent" [component]="component"> </div>
          </div>
        </div>
      </ng-container>
    </div>
  </form>
</ng-template> -->

<!-- group -->
<ng-template #groupRender let-subComponent let-parentComponent="parentComponent" let-index="index">
  <!-- 列表 -->
  <nz-form-item class="widget-form-item r-d-groups" [ngClass]="{ required: subComponent.required, bordered: parentComponent.bordered }">
    <nz-form-label *ngIf="!parentComponent.bordered" [hidden]="subComponent.hiddenLabel" [nzRequired]="subComponent.required" nzSpan="24">
      <div>{{ subComponent.label }}</div>
    </nz-form-label>
    <nz-form-control nzSpan="24" *ngIf="subComponent.children.length">
      <!-- 渲染子项 -->
      <ng-container *ngFor="let childrenComponent of subComponent.children; let i = index">
        <div
          nz-col
          [nzMd]="childrenComponent.span || 12"
          [nzXs]="24"
          [nzOffset]="childrenComponent.offset || 0"
          class="widget-form-list-item"
          [attr.data-id]="childrenComponent.id"
          [attr.id]="'widget-' + childrenComponent.id"
          style="display: inline-block; width: 100%; float: left"
        >
          <div r-widget-form-render [parentComponent]="subComponent" [component]="childrenComponent"> </div>
        </div>
      </ng-container>
    </nz-form-control>
    <div class="line-top" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
    <div class="line-right" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
    <div class="line-bottom" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
    <div class="line-left" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
  </nz-form-item>
</ng-template>

<!-- title -->
<ng-template #titleRender let-subComponent let-parentComponent="parentComponent" let-index="index">
  <nz-form-item
    class="widget-form-item r-d-title"
    [ngClass]="{ required: subComponent.required, bordered: parentComponent.bordered, parentGroup: parentComponent.widget === 'group' }"
  >
    <nz-form-control>
      <!-- 渲染title控件 -->
      <div r-widget-form-item [item]="subComponent"></div>
    </nz-form-control>
    <div class="line-top" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
    <div class="line-right" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
    <div class="line-bottom" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
    <div class="line-left" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
  </nz-form-item>
</ng-template>

<!-- 默认 -->
<ng-template #defaultRender let-subComponent let-parentComponent="parentComponent" let-index="index">
  <nz-form-item
    class="widget-form-item"
    [ngClass]="{
      required: subComponent.required,
      bordered: parentComponent.bordered,
      parentGroup: parentComponent.widget === 'group'
    }"
  >
    <!-- 显示边框时，隐藏label， parentComponent.bordered -->
    <!-- 标题 -->
    <nz-form-label
      *ngIf="!parentComponent.bordered"
      [hidden]="subComponent.hiddenLabel"
      [style.width]="getLabelWidth(subComponent)"
      [nzRequired]="subComponent.required"
    >
      <div>{{ subComponent.label }}</div>
    </nz-form-label>
    <nz-form-control>
      <r-widget-form-item [item]="subComponent"></r-widget-form-item>
    </nz-form-control>
    <div class="line-top" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
    <div class="line-right" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
    <div class="line-bottom" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
    <div class="line-left" [ngStyle]="{ display: parentComponent.widget === 'group' ? 'none' : 'block' }"></div>
  </nz-form-item>
</ng-template>
